function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { useCallback } from 'react';
const api = buildService('/claim_groups/{id}/claim_template_tasks', {
  only: ['update']
});
const useUpdateClaimGroupTask = _ref => {
  let {
    claimGroup,
    setClaimGroup,
    setLoading,
    handleToaster
  } = _ref;
  const updateClaimGroupTask = useErrorHandling(useCallback(async _ref2 => {
    let {
      taskIndex,
      categoryIndex,
      field,
      value
    } = _ref2;
    console.log('update called with', _objectSpread({}, {
      taskIndex,
      categoryIndex,
      field,
      value
    }));
    setLoading && setLoading(true);
    const updatedClaimGroup = await api.update(claimGroup.id, taskIndex, {
      category_index: categoryIndex,
      field,
      value
    });
    setClaimGroup(_objectSpread({}, updatedClaimGroup));
    handleToaster && handleToaster('Task Updated!');
  }, [claimGroup, handleToaster, setClaimGroup, setLoading]), useCallback(() => {
    setLoading && setLoading(false);
  }, [setLoading]));
  return updateClaimGroupTask;
};
const claimTemplateTasksService = {
  useUpdateClaimGroupTask
};
export default claimTemplateTasksService;